import { rem } from '@mantine/core';
import ShadeGeneratorLib, { type IShadeGenerator, type Shade } from 'shade-generator';

// @ts-expect-error Tailwindcss have problems loading default exports, we need to
// make sure to use the default export of shade-generator
const ShadeGenerator: IShadeGenerator = ShadeGeneratorLib.default || ShadeGeneratorLib;

/* Same as tailwindcss default breakpoints */
export const breakpoints = {
  sm: '40em', // 640px
  md: '48em', // 768px
  lg: '64em', // 1024px
  xl: '80em', // 1280px
  '2xl': '96em', // 1536px
};

export const colors = {
  // prettier-ignore
  primary: [
    '#f7f0ff', // [0] 50  - lightest
    '#f0e6ff', // [1] 100
    '#d9b8ff', // [2] 200
    '#bf85ff', // [3] 300
    '#a652ff', // [4] 400
    '#8c1fff', // [5] 500
    '#6600ff', // [6] 600 - base (#6600FF = primary-700 in Tailwind)
    '#5200cc', // [7] 700
    '#3d0099', // [8] 800
    '#290066', // [9] 900 - darkest
  ] as unknown as [string, string, string, string, string, string, string, string, string, string],
  // prettier-ignore
  secondary: [
    '#eef2ff', // [0] 50  - lightest
    '#c7d2fe', // [1] 100
    '#a5b4fc', // [2] 200
    '#818cf8', // [3] 300
    '#6366f1', // [4] 400
    '#4f46e5', // [5] 500 - base indigo
    '#4338ca', // [6] 600
    '#3730a3', // [7] 700
    '#312e81', // [8] 800
    '#1e1b4b', // [9] 900 - darkest
  ] as unknown as [string, string, string, string, string, string, string, string, string, string],
  green: createColorArray('#15C15D'), // Success color
  yellow: createColorArray('#F59E0B'), // Warning color
  blue: createColorArray('#3B82F6'), // Info color
  red: createColorArray('#EF4444'), // Error color
  light: createColorArray('#F9FAFB'), // Background color
  dark: createColorArray('#111827'), // Text color
  darkAccent: createColorArray('#00319c'), // Dark accent color (used for dark contrasts or emphasis)
};

export const spacings = {
  xs: rem(4),
  sm: rem(8),
  md: rem(16),
  lg: rem(24),
  xl: rem(32),
};

export const fontSize = {
  xs: rem(12),
  sm: rem(14),
  md: rem(16),
  lg: rem(18),
  xl: rem(20),
};

// Function to create an array of 10 different shades of a color
function createColorArray(color: string) {
  const config: Record<Shade, number> = {
    '10': 0,
    '20': 0,
    '30': 0,
    '40': 0.9,
    '50': 0.75,
    '60': 0.6,
    '70': 0.45,
    '80': 0.3,
    '90': 0.15,
    '100': 0,
    '200': 0.9,
    '300': 0.8,
    '400': 0.7,
    '500': 0,
    '600': 0,
    '700': 0,
    '800': 0,
    '900': 0,
    '1000': 0,
  };

  const colorMap = ShadeGenerator.hue(color).config(config).shadesMap('rgba');
  const colors = [
    colorMap['40'],
    colorMap['50'],
    colorMap['60'],
    colorMap['70'],
    colorMap['80'],
    colorMap['90'],
    colorMap['100'],
    colorMap['200'],
    colorMap['300'],
    colorMap['400'],
  ] as const;

  return colors;
}
